import { Toggle } from '@base-ui/react/toggle';
import { ToggleGroup } from '@base-ui/react/toggle-group';

import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

import type { QueueFieldOption } from './fieldOptions';

type ClSideToggleProps = {
  value: number | null | undefined;
  options: QueueFieldOption<number>[];
  label: string;
  disabled?: boolean;
  onChange: (value: number | null) => void;
};

export const ClSideToggle = ({
  value,
  options,
  label,
  disabled = false,
  onChange,
}: ClSideToggleProps) => (
  <ToggleGroup
    aria-label={label}
    value={value === null || value === undefined ? [] : [String(value)]}
    disabled={disabled}
    onValueChange={(next) => onChange(next.length ? Number(next[0]) : null)}
    className="inline-flex items-center"
  >
    {options.map((option) => (
      <Toggle
        key={option.value}
        value={String(option.value)}
        className={cn(
          buttonVariants({ variant: 'outline', size: 'xs' }),
          'min-w-12 rounded-none not-first:-ml-px first:rounded-l-md last:rounded-r-md',
          'text-muted-foreground focus-visible:z-10',
          'data-[pressed]:border-primary data-[pressed]:bg-primary data-[pressed]:text-primary-foreground data-[pressed]:z-[1]',
          'data-[pressed]:hover:bg-primary/90 data-[pressed]:hover:text-primary-foreground',
        )}
      >
        {option.label}
      </Toggle>
    ))}
  </ToggleGroup>
);
